module.exports = __webpack_public_path__ + "img/staff-setting.7e97b13e.png";